module.exports = __webpack_public_path__ + "static/img/Snipaste_2023-06-14_09-43-10.4d95455c.jpg";